import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();
  isDashboardLoading = new BehaviorSubject<boolean>(false);

  constructor() { }

  setLoading(isLoading: boolean): void {
    this.isLoadingSubject.next(isLoading);
  }
}
